import type { PrivateEventDetail } from '../../api/privateEvents';
import { EditSection } from '../shared/EditSection';

import WhenWhatEditable from './WhenWhatEditable';
import WhenWhatView from './WhenWhatView';

export default function WhenWhatSection({
  event,
  readOnly,
  denied,
  onDenied,
}: {
  event: PrivateEventDetail;
  readOnly: boolean;
  denied: boolean;
  onDenied: () => void;
}) {
  if (!readOnly) return <WhenWhatEditable event={event} frozen={denied} onDenied={onDenied} />;
  return (
    <EditSection
      first
      readOnly
      title="When & what"
      editLabel="Edit When & what"
      view={<WhenWhatView event={event} />}
      form={null}
      onSave={() => Promise.resolve()}
    />
  );
}
